module.exports = __webpack_public_path__ + "img/p49.ea0d7599.jpg";